import { render, staticRenderFns } from "./secondSubject.vue?vue&type=template&id=35870418&scoped=true&"
import script from "./secondSubject.vue?vue&type=script&lang=js&"
export * from "./secondSubject.vue?vue&type=script&lang=js&"
import style0 from "./secondSubject.vue?vue&type=style&index=0&id=35870418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35870418",
  null
  
)

export default component.exports